module.exports = __webpack_public_path__ + "img/icon-taken-by-recipient.d711fde7.svg";